import { Phone } from "@element-plus/icons-vue/dist/types";

export default {
	realPay: "Total",
	loginTitle: "By logging in, you agree to the Terms of Service and Privacy Policy",
	nav: {
		home: "Home",
		services: "Services",
		about: "About Us",
		help: "Help",
		myBooking: "My Booking",
		login: "Login",
		register: "Register",
		logoutConfirm: "Are you sure you want to exit?",
		logTip: "Prompt",
		ok: "OK",
		cancel: "Cancel",
	},
	busconfirm: {
		phone: "Phone",
		//必填
		contactInformation: "Contact email is required",
		userName: "User Name is required",
		amoutSmall: "The amount is too small, please enter a larger amount",
		orderInfo: "Booking Information",
		passengers: "{adult} Adult(s) {child} Child(ren)",
		bookingInfo: "Customer Information",
		name: "Name",
		contact: "Email",
		payment: "Confirm Payment",
		paymentTime0: "Please",
		paymentTime1: "complete payment within",
		terms: "Terms of Use",
		policy: "Cancellation Policy",
		paymentBtn: "Pay",
		srxm: "Please enter your name",
		srlx: "Please enter your contact information",
		fhsyy: "backup",
	},
	footer: {
		company: {
			title: "Company",
			media: "Media",
			environmental: "Green Travel",
			partner: "Become a Driver Partner",
		},
		aboutUs: {
			title: "About Us",
			overview: "Overview",
			travelAgency: "Become our partner",
			description: "LanePlus — Your intelligent travel platform, specializing in charter tours, airport transfers, and travel car services.",
		},
		aboutUs0: {
			title: "How Laneplus works",
			overview: "Overview",
			travelAgency: "Travel Agency",
			description: `How Laneplus works
LanePlus connects global travelers with local professional long-distance travel car service providers in Australia, New Zealand, and Asia through our technology platform, making it easy to book reliable ride services. We do not directly provide or manage ride services but support local providers through our technology, especially in the field of long-distance travel.

Our pricing system is transparent and flexible, dynamically calculated based on vehicle type, distance, and travel time. Travelers can use our bidding system to choose the long-distance travel service that best fits their needs. Our revenue comes from providing technology support to local service providers, helping them better serve international travelers.

LanePlus is dedicated to combining regional strengths with a global booking experience, delivering convenient and efficient car service solutions for long-distance travel.`,
		},
		aboutUs1: {
			title: "Sustainable Travel",
			description: "Sustainable Travel",
		},
		subTitle4_7: `
        LanePlus is committed to advancing sustainable travel through technological innovation, offering global travelers green and efficient long-distance transportation options. We actively promote and prioritize electric vehicle (EV) services to reduce carbon emissions and minimize environmental impact.

By collaborating with local providers to expand EV fleets, we aim to integrate eco-conscious practices into every journey and contribute to a zero-emission future.

Choosing LanePlus means more than just a convenient long-distance trip—it’s a step toward a greener tomorrow. Together, let’s connect the world with technology while protecting our planet.`,
		aboutUs2: {
			title: "About us",
			overview: "LanePlus — Redefining Every Journey",
			description: `LanePlus specializes in charter tours, airport transfers, and travel car services, offering global travelers an efficient, safe, and personalized travel experience. By combining advanced technology with localized services, our intelligent matching system and user-friendly booking process make your journeys more convenient and efficient.`,
		},
		subTitle4_8: `<div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; background-color: #f9f9f9; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
  <h2 style="text-align: center; color: #4CAF50; font-size: 24px; margin-bottom: 20px;">Why Choose LanePlus?</h2>
  <p style="margin-bottom: 10px;"><strong style="color: #4CAF50;">● Easy Booking:</strong> Complete your booking in just a few steps, quickly and hassle-free.</p>
  <p style="margin-bottom: 10px;"><strong style="color: #4CAF50;">● Secure Payments:</strong> Multiple payment options ensure safe and worry-free transactions.</p>
  <p style="margin-bottom: 10px;"><strong style="color: #4CAF50;">● Diverse Choices:</strong> From budget-friendly cars to luxury business vehicles, we meet various needs and budgets.</p>
  <p style="margin-bottom: 10px;"><strong style="color: #4CAF50;">● Safe Travels:</strong> All drivers are carefully vetted and professionally trained to provide a reliable service experience.</p>
  <p style="margin-top: 20px; font-weight: bold; text-align: center; font-size: 16px;">Whether it’s intercity travel, holiday charters, or airport transfers, LanePlus is dedicated to making your journey smoother and more enjoyable.<br>LanePlus, redefining every journey.</p>
</div>
`,
		aboutUs3: {
			title: "Airport Transfer",
			overview: "Services",
			description: ``,
		},
		subTitle4_9: `<div style="padding: 20px;">
  <section>
    <h2 style="font-size: 1.5em; margin-bottom: 10px;">Service Overview</h2>
    <p>LanePlus offers reliable airport transfer services across major cities in Australia, New Zealand, and Asia. From the airport to your hotel or from home to the airport, our professional drivers ensure a smooth and stress-free journey.</p>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">Service Highlights</h3>
    <ul style="list-style-type: none; padding: 0;">
      <li>● On-Time Guarantee: Real-time flight tracking ensures your driver is always on time, even with delays.</li>
      <li>● Vehicle Options: Choose from economy cars to luxury vehicles to match your needs.</li>
      <li>● Door-to-Door Service: Enjoy a seamless experience from pickup to drop-off.</li>
      <li>● Transparent Pricing: No hidden fees—what you see is what you pay.</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">Perfect For</h3>
    <ul style="list-style-type: none; padding: 0;">
      <li>● Business travelers</li>
      <li>● Families or groups</li>
      <li>● Early morning or late-night flights</li>
    </ul>
  </section>

  <p>Book Now and make your airport transfer worry-free!</p>
</div>

`,
		aboutUs4: {
			title: "Travel Charter",
			overview: "Service Overview",
			description: `LanePlus provides flexible and efficient travel charter services. Whether it’s a day tour, multi-day trip, or intercity travel, we tailor the itinerary to meet your needs, offering the most comfortable way to explore.`,
		},
		subTitle4_10: `<div style="padding: 20px;">
  <section>
    <h2 style="font-size: 1.5em; margin-bottom: 10px;">Service Highlights</h2>
    <ul style="list-style-type: none; padding: 0;">
      <li>● Custom Itineraries: Plan your trip the way you want and enjoy every moment.</li>
      <li>● Experienced Drivers: Local drivers with expert knowledge can guide you to the best spots.</li>
      <li>● Vehicle Options: From family-friendly cars to luxury business vehicles, we cater to every group size and need.</li>
      <li>● Cost-Effective: Pay per day or per trip with no surprise charges.</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">Popular Routes</h3>
    <ul style="list-style-type: none; padding: 0;">
      <li>● Australia: Great Ocean Road Day Tour, Blue Mountains National Park</li>
      <li>● New Zealand: Hobbiton Village, Queenstown and Surroundings</li>
      <li>● Asia: Customizable itineraries for cultural and natural exploration</li>
    </ul>
  </section>

  <p>Contact Us today to start your personalized travel adventure!</p>
</div>
`,
		aboutUs5: {
			title: "Become Our Partner with LanePlus",
			overview: "",
			description: `At LanePlus, we are committed to delivering exceptional travel experiences through our reliable and professional partners. Whether you are a business or an individual driver, joining our platform means becoming part of a trusted network that connects travelers with top-notch transport services.`,
		},
		subTitle4_11: `<div style="padding: 20px;">
  <section>
    <h2 style="font-size: 1.5em; margin-bottom: 10px;">Eligibility Requirements</h2>
    
    <h3 style="font-size: 1.2em;">For Businesses</h3>
    <p>To become a partner as a business, you must:</p>
    <ul style="list-style-type: none; padding: 0;">
      <li>● Hold a Booking Service Provider (BSP) accreditation as required by the relevant transport authority.</li>
      <li>● Ensure that all vehicles and drivers meet the local regulatory standards for passenger transport services.</li>
    </ul>

    <h3 style="font-size: 1.2em;">For Individual Drivers</h3>
    <p>To join as an individual partner, you must meet the following criteria:</p>
    <ul style="list-style-type: none; padding: 0;">
      <li>● Your vehicle must be registered as a Commercial Passenger Vehicle (CPV).</li>
      <li>● You must hold a valid Driver Accreditation issued by the transport authority in your area.</li>
      <li>● Maintain a clean and well-presented vehicle to provide the best customer experience.</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">Why Partner with LanePlus?</h3>
    <ul style="list-style-type: none; padding: 0;">
      <li>● Expand Your Reach: Gain access to a growing base of travelers seeking reliable transport options.</li>
      <li>● Flexible Opportunities: Set your own schedule and take advantage of our user-friendly platform.</li>
      <li>● Support and Training: Benefit from our dedicated support team and resources to ensure success on the platform.</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">How to Apply</h3>
    <ol style="padding: 0;">
      <li>Contact Us via Email: Send an inquiry to our team at <a href="mailto:support&#64;laneplus.com.au" style="color: #007bff;">support&#64;laneplus.com.au</a> to express your interest in becoming a LanePlus partner.</li>
      <li>Provide Documentation: Upon receiving your inquiry, our team will guide you through the process and request the necessary documentation, such as BSP accreditation (for businesses) or CPV registration and Driver Accreditation (for individuals).</li>
      <li>Verification Process: We will carefully review and verify your eligibility before confirming your partnership.</li>
    </ol>
  </section>
</div>
`,
		aboutUs6: {
			title: "Melbourne",
			overview: "",
			description: `Melbourne, Australia’s cultural and sporting capital, is renowned for its vibrant art scene, laneway cafés, and dynamic lifestyle.It’s a city where modern skyscrapers meet Victorian architecture, and the atmosphere is always alive with festivals and events.`,
		},
		melbourne: {
			title: "Melbourne",
			overview: "Melbourne",
			description:
				"Melbourne is Australia's cultural and sporting capital, known for its vibrant arts scene, laneway cafes, and dynamic lifestyle. The city beautifully blends modern skyscrapers with Victorian-era architecture, and hosts a variety of festivals and events throughout the year.",
			recommendedActivities:
				"<h3 style='font-size: 28px; font-weight: bold; color: #333; margin-bottom: 20px;'>Recommended Activities</h3><ul style='list-style-type: none; padding: 0; margin: 0;'><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Great Ocean Road Day Tour:</span> Experience the scenic coastal road, visit the Twelve Apostles, and explore the natural wonders of the Otway Rainforest.</li><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Phillip Island Penguin Parade:</span> Watch the adorable penguins return to their burrows at night, a great experience for the whole family.</li><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Yarra Valley Winery Tour:</span> Enjoy fine wine and food in one of Australia's most famous wine regions.</li></ul>",
		},
		sydney: {
			title: "Sydney",
			overview: "Sydney",
			description:
				"Sydney, Australia's iconic city, is famous for its landmark architecture, beautiful beaches, and stunning harbor. The city offers the perfect blend of modern style and natural beauty, making it a popular destination for travelers.",
			recommendedActivities:
				"<h3 style='font-size: 28px; font-weight: bold; color: #333; margin-bottom: 20px;'>Recommended Activities</h3><ul style='list-style-type: none; padding: 0; margin: 0;'><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Blue Mountains National Park Day Tour:</span> Explore steep cliffs, waterfalls, and eucalyptus forests, a UNESCO World Heritage site.</li><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Bondi to Coogee Coastal Walk:</span> Stroll along this scenic trail, enjoying the breathtaking views of Sydney's famous beaches.</li><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Hunter Valley Winery Tour:</span> Taste premium wines, cheeses, and chocolates in Australia's oldest wine region.</li></ul>",
		},
		adelaide: {
			title: "Adelaide",
			overview: "Adelaide",
			description: "Adelaide is a charming city known for its relaxed lifestyle, lively festivals, and world-class wine regions. It serves as a gateway to explore the diverse natural wonders of South Australia.",
			recommendedActivities:
				"<h3 style='font-size: 28px; font-weight: bold; color: #333; margin-bottom: 20px;'>Recommended Activities</h3><ul style='list-style-type: none; padding: 0; margin: 0;'><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Barossa Valley Winery Tour:</span> Sample world-class wines in one of Australia's most renowned wine regions.</li><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Kangaroo Island Day Tour:</span> Meet unique wildlife and explore pristine beaches in this nature-lover's paradise.</li><li style='padding: 15px 0; font-size: 1.2em; line-height: 1.8; position: relative;'> <span style='font-weight: bold; color: #333;'>Adelaide Hills & Hahndorf Village Tour:</span> Stroll through picturesque hills and discover the charm of Australia's oldest German settlement.</li></ul>",
		},
		subTitle4_12: `●Top Activities:
●Great Ocean Road Day Tour: Experience the stunning coastal drive, visit the Twelve Apostles, and explore the lush rainforests of the Otway Ranges.
●Phillip Island Penguin Parade: Witness the adorable nightly march of penguins returning to their nests.
●Yarra Valley Wine Tasting: Enjoy premium wine and gourmet food in one of Australia’s most famous wine regions.

Sydney 悉尼
Sydney, the heart of Australia, is famous for its iconic landmarks, beautiful beaches, and vibrant harbor. The city offers a perfect blend of urban sophistication and natural beauty, making it a favorite destination for travelers.
●Top Activities:
●Blue Mountains National Park Tour: Explore rugged cliffs, waterfalls, and eucalyptus forests in this UNESCO World Heritage site.
●Bondi to Coogee Coastal Walk: Enjoy breathtaking ocean views on this scenic trail connecting Sydney’s most popular beaches.
●Hunter Valley Wine Tours: Savor the best wines, cheeses, and chocolates in one of Australia’s oldest wine regions.

Adelaide 阿德莱德
Adelaide is a charming city known for its relaxed lifestyle, vibrant festivals, and world-class wine regions. Surrounded by stunning natural landscapes, it’s a gateway to exploring South Australia’s diverse attractions.
●Top Activities:
●Barossa Valley Wine Tour: Taste some of the world’s finest wines in Australia’s most famous wine region.
●Kangaroo Island Day Trip: Encounter unique wildlife and pristine beaches on this nature-lover’s paradise.
●Adelaide Hills & Hahndorf Village Visit: Wander through picturesque hills and discover Australia’s oldest German settlement.
`,
		popularCities: {
			title: "Popular Cities",
			newYork: "Melbourne",
			london: "Sydney",
			berlin: "Adelaide",
			la: "Los Angeles",
			paris: "Paris",
			allCities: "All Cities",
		},
		serviceTypes: {
			title: "Service Types",
			longDistance: "Long Distance",
			luxuryCar: "Luxury Car Service",
			exclusiveDriver: "Exclusive Driver",
			privateCharter: "Private Charter",
			busService: "Bus Service",
			airportTransfer: "Airport Transfer",
			airportP: "Airport pick-up service",
			airportP0: "place of departure",
		},
		contact: {
			title: "Contact Us",
			email: "Email:",
			Email: "Email: +86 1833-422-3338",
			address: "Address: 151 George Street, Winchester, SO23 8BU",
		},
		copyright: {
			text: "Copyright © 2024 LanBry",
			terms: "Terms",
			termsUrl: "https://www.laneplus.com.au/common/LanePlus%20Consumer%20Terms%20and%20Conditions.pdf",
			privacy: "Privacy Policy",
			privacyUrl: "https://www.laneplus.com.au/common/LanePlus%20Privacy%20Policy.pdf",
			legal: "Legal Notice",
			accessibility: "Accessibility",
		},
	},
	login: {
		title: "Welcome Back",
		tips1: "Safe",
		tips2: "Easy",
		tips3: "Convenient",
		account: "Account",
		password: "Password",
		forgotPassword: "Forgot Password",
		loginBtn: "Login",
		register: "Quick Register",
		agreement: "By logging in, you agree to our",
		serviceAgreement: "Service Agreement",
		privacyPolicy: "Privacy Policy",
		authAgreement: "Authorization Agreement",
		EmailLogin: "Email Login",
		passwordLogin: "Password Login",
		verificationCode: "Verification Code",
		getCode: "Get Code",
		resendCode: "Resend",
		phone: "Email",
		Email: "Email Number",
		phoneLogin: "Email Login",
	},
	register: {
		title: "Welcome to Register",
		username: "Username",
		Email: "Email Number",
		password: "Password",
		verificationCode: "Verification Code",
		getCode: "Get Code",
		hasAccount: "Have an account?",
		goLogin: "Go to Login",
		registerBtn: "Register",
		repetSend: "Resend",
	},
	airport: {
		pickup: "Airport Pickup",
		dropoff: "Airport Drop-off",
		selectAirport: "Select Airport Transfer",
		pickupAddress: "Pickup Address",
		dropoffAddress: "Drop-off Address",
		dateTime: "Date & Time",
		flightInfo: "Flight Info",
		passengers: "Passengers",
		luggage: "Luggage",
		children: "Children aged 16 and under",
		selectCar: "Select Car",
		payComment: 'By clicking "Pay," you confirm that you have reviewed your booking Details and the total amount, and you agree to the Terms of Use and Cancellation Policy.',
		book: "Book Now",
		waitingTime: "Driver will wait 30 minutes free of charge.",
		airportInfro: "Enter flight information (flight number)",
		qijia: "",
		adult: "Adult and 16YRS+",
		lc: "Mileage (kilometers)",
		zje: "Total amount",
	},
	message: {
		required: {
			airport: "Please select an airport",
			datetime: "Please select date and time",
			dropoff: "Please enter drop-off address",
			pickup: "Please enter pickup address",
			carType: "Please select a car type",
		},
	},
	home: {
		titleTip: "Private Charter Tour",
		subTitle: "Airport Transfer",
		subTitle2: "Pickip",
		subTitle3: "Drop-off",
		heroTitle: "Explore Australia Your Way",
		heroSubtitle: "Private transfers, day tours & charter experiences — book direct, no middleman",
		browseTours: "Browse Tours",
		viewDetails: "View Details",
		alsoOn: "Also available through",
		whyTitle: "Why Book with LanePlus?",
		badge: { private: "Private" },
		tag: {
			confirm: "Instant Confirm",
			private: "Private Tour",
		},
		trust1: "Local Operator",
		trust2: "Secure Booking",
		trust3: "CN / EN Support",
		service: {
			airport: "Airport Transfer",
			dayTour: "Day Tours",
			charter: "Private Charter",
			cruise: "Cruise Pickup",
		},
		why1: { title: "Local Operator", desc: "Based in Australia, we know every route." },
		why2: { title: "Direct Booking Price", desc: "No platform fees — book direct and save." },
		why3: { title: "Chinese & English", desc: "Fully bilingual service for all travelers." },
		why4: { title: "Flexible Private Tours", desc: "Customise your itinerary, your way." },
		why5: { title: "Reliable Communication", desc: "WhatsApp support before and during your trip." },
		why6: { title: "Trusted Experience", desc: "Hundreds of happy travelers across Australia." },
	},
	services: {
		title: "Our Services",
		subTitle1: "Airport Transfer",
		subTitle1_1: "Competitive rates",
		subTitle1_1_info: "We offer affordable and transparent pricing to ensure you get the best value for your journey.",
		subTitle1_2: "Flexibility",
		subTitle1_2_info: "Enjoy the freedom to customize your itinerary and choose from a wide range of vehicle options.",
		subTitle1_3: "Relibility",
		subTitle1_3_info: "Our team is available to assist you every step of the way, ensuring a smooth and worry-free experience.	",
		subTitle1_4: "Sustainability",
		subTitle1_4_info: "We support eco-friendly travel by offering electric vehicle options, helping reduce your carbon footprint while exploring comfortably.",

		subTitle2: "Private Charter Tour",
		subTitle2_1: "Convenient and Comfortable for Your Travel",
		subTitle2_1_info:
			"Our charter tours are designed to deliver a seamless and comfortable travel experience. Backed by technology, we simplify the booking process to save you time and effort while creating exceptional value. With a diverse fleet ranging from 5-seaters to 12-seaters, we cater to individuals, families, and groups. Whether you're planning a private charter, half-day tour, full-day excursion, or group trip, our personalized services ensure every journey exceeds expectations, combining convenience, innovation, and quality.",
		subTitle2_2: "Relax and Enjoy the Ride",
		subTitle2_2_info: "Say goodbye to the stress of navigating unfamiliar routes or coordinating transportation for groups. With our professional service, we handle every detail, so you can focus on enjoying your journey.",
		subTitle2_3: "Secure Payment Options",
		subTitle2_3_info: "We prioritize your security with trusted payment systems that protect your information at every step. Choose from a variety of payment methods for a hassle-free checkout.",
		subTitle2_4: "Tailored to Your Needs",
		subTitle2_4_info: "Flexibility is at the core of our service. Customize your tour to include your preferred destinations, timing, and vehicle type for a truly personalized experience.",

		subTitle3: "We have served 1036 customers",
		subTitle4: "Submit your request online and we will assist you shortly. ",
		subTitle4_1: "Yor name (required)",
		subTitle4_2: "Your mobile or email (required)",
		subTitle4_3: "Your message (required)",
		subTitle4_4: "Submit Now",
		subTitle4_5:
			"LanePlus — Your intelligent travel platform, specializing in charter tours, airport transfers, and travel car services. We deliver an efficient, secure, and personalized travel experience for global travelers, redefining every journey with technology and innovation.\n" +
			"\n" +
			"By combining cutting-edge technology with localized expertise, our platform offers an intelligent vehicle-matching system and a seamless booking experience, making travel simpler and stress-free. Whether you need a comfortable family car, a luxurious business vehicle, airport transfers, or single-day charter tours, our wide range of vehicle options ensures the perfect fit for every occasion.\n" +
			"\n" +
			"Why Choose LanePlus?\n" +
			"Technology-Driven Solutions\n" +
			"Powered by advanced algorithms and data-driven systems, we provide precise and efficient vehicle matching to optimize your travel experience.\n" +
			"Effortless Booking\n" +
			"Complete your reservations in just a few simple steps with secure, hassle-free online payments, giving you peace of mind.\n" +
			"Diverse Choices\n" +
			"From budget-friendly cars to premium vehicles, we offer a variety of options tailored to suit different needs, preferences, and budgets.\n" +
			"Safe and Reliable Service\n" +
			"All drivers are rigorously vetted and professionally trained to deliver a safe, trustworthy, and high-quality travel experience.\n" +
			"Whether you’re traveling between cities, exploring new destinations, or heading to the airport, LanePlus offers flexible and customized travel solutions designed to make your journeys easier, safer, and more enjoyable.\n" +
			"\n" +
			"Technology-Driven. Service-Oriented. — LanePlus is redefining what travel should be.\n",
		subTitle4_6: `How Laneplus works
LanePlus connects global travelers with local professional long-distance travel car service providers in Australia, New Zealand, and Asia through our technology platform, making it easy to book reliable ride services. We do not directly provide or manage ride services but support local providers through our technology, especially in the field of long-distance travel.

Our pricing system is transparent and flexible, dynamically calculated based on vehicle type, distance, and travel time. Travelers can use our bidding system to choose the long-distance travel service that best fits their needs. Our revenue comes from providing technology support to local service providers, helping them better serve international travelers.

LanePlus is dedicated to combining regional strengths with a global booking experience, delivering convenient and efficient car service solutions for long-distance travel.`,
	},
	help: {
		title: "Hello, can we help you with anything?",
		subTitle1: "Questions",
	},
	order: {
		payPrice: "Payable amount",
		Details: "Details",
		pay_item: "Currency type",
		pay_item0: "Email",
		pay_item1: "Bank card information",
		pay_item2: "close",
		pay_item3: "Please select",
		pay_item4: "Finished",
		pay_item5: "Pending payment",
		pay_create_time: "Payment creation time",
		pay_item6: "paid",
		pay_item7: "Cancelled",
		pay_item8: "refund",
		pay_item9: "Immediate payment",
		pay_item10: "Your order has been cancelled. Looking forward to seeing you again next time！",
		pay_item11: "Your order has been serviced and we look forward to seeing you again next time",
		pay_item12: "Your order has been paid for and a driver is being arranged. Please be patient and wait",
		pay_item13: "Your order has not been paid for the remaining balance yet",
		pay_item14: "airport",
		pay_item15: "Disbursements",
		pay_item16: "Payment method",
		pay_item17: "time of payment",
		pay_item18: "Booking person information",
		pay_item19: "Pay",
		pay_item20: "meet",
		pay_item21: "confirm the payment",
		pay_item22: "Please",
		pay_item23: "Complete payment internally",
		pay_item24: "please log in first",
		pay_item25: "Obtain verification code",
		pay_item26: "Resend",
		pay_item27: "Please enter your email address",
		pay_item28: "Verification code sent successfully",
		pay_item29: "Login succeeded",
		pay_item30: "Please enter the verification code",
		pay_item31: "Email format incorrect",
		pay_item32: "Destination error, please reselect the destination",
		pay_item33: "Please enter the correct email address",
		pay_item34: "Please select currency type",
	},
};
